module.exports = __webpack_public_path__ + "media/eyejack-webar-murals-comp.bf171e78.mp4";